import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { IhmNotificationMessage } from '../ihm-notifications/interfaces/ihm-notifications.interface';

@Component({
  selector: 'ihm-header',
  templateUrl: './ihm-header.component.html',
  styleUrls: ['./ihm-header.component.scss']
})
export class IhmHeaderComponent implements OnInit {
  @Input() username = 'Tester';
  @Input() userEmail = '';
  @Input() showIcons = true;
  @Input() dropdown = false;
  @Input() appName = 'App Name';
  @Input() theme = 'proposal';
  @Input() notifications: IhmNotificationMessage[];
  pageTitle: string;
  topOfPage = true;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    // Get initial page title. Since router events may have already fired in a lazy loaded module,
    // we must loop through the activatedRoute snapshot and look at each child's data
    let snapshot = this.route.snapshot;
    let title;
    do {
      if (snapshot.data && snapshot.data.title) {
        title = snapshot.data.title;
      }
      if (snapshot.firstChild) {
        snapshot = snapshot.firstChild;
      }
    } while (snapshot.firstChild);
    this.pageTitle = title;

    // subscribe to future router events to change page title
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.route),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        this.pageTitle = data.title;
      });
  }

  logout() {
    this.router.navigateByUrl('/logout');
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
  }

  @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    this.topOfPage = window.pageYOffset === 0;
  }

  @HostListener('document:click', ['$event']) clickedOutsideDropBox($event) {
    if (this.dropdown) {
      if (!$event.target.className.includes('user-image')) {
        this.dropdown = false;
      }
    }
  }

  hasNotificationMessages(): boolean {
    return this.notifications && this.notifications.length > 0;
  }
}
